import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./PolicyMeetings.css";
import Footer from "../Home/Footer";
import PolicyMeetings1 from "../assets/img/PolicyMeetings1.png";
import PolicyMeetings2 from "../assets/img/PolicyMeetings2.png";
import PolicyMeetings3 from "../assets/img/PolicyMeetings3.png";

const policyMeetings = [
  {
    id: 1,
    title:
      "Policy Dialogue Group Meeting on Discussion of Challenges and Interventions in Pulses ",
    date: "08th August 2024",
    location: "Online",
    image: PolicyMeetings1,
  },
  {
    id: 2,
    title:
      "Policy Dialogue Group Meeting on Exploring synergies between Producers, Processors, & Policies",
    date: "21st February 2025 ",
    location: "Nagpur",
    image: PolicyMeetings2,
  },
  {
    id: 3,
    title:
      "Policy Dialogue Group Meeting on Alternative Protein through Pulses and Other Pulse-Based Innovative Products",
    date: "20th June 2025 ",
    location: "Mumbai",
    image: PolicyMeetings3,
  },
];

const PolicyMeetings = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="policy-page">
      {/* Hero Section */}
      <div className="policy-hero" data-aos="fade-up">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1 data-aos="fade-down">Policy Dialogue Group Meetings</h1>
          <p data-aos="fade-up">
            Engaging discussions shaping the future of policies in India.
          </p>
        </div>
      </div>

      {/* Meetings Section */}
      <section className="meetings-section container">
        <h2
          className="separator-title text-center"
          style={{ color: "#d4561a" }}
          data-aos="fade-up"
        >
          Policy Dialogue Group Meetings
        </h2>
        <div className="separator-line mb-5"></div>

        <div className="meetings-grid">
          {policyMeetings.map((meeting, index) => (
            <div
              key={meeting.id}
              className="meeting-card"
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <div className="image-wrapper">
                <img
                  src={meeting.image}
                  alt={meeting.title}
                  className="meeting-image"
                />
              </div>
              <div className="meeting-content">
                <h3 title={meeting.title}>{meeting.title}</h3>
                <p className="meeting-date">
                  📅 {meeting.date} | 📍 {meeting.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PolicyMeetings;
